// extracted by mini-css-extract-plugin
module.exports = {"confirmationBox":"ConfirmationBox_confirmationBox__3U0wl","text":"ConfirmationBox_text__2-6C-","buttons":"ConfirmationBox_buttons__3RoGx"};